<template>
  <base-dropdown @change="hideKnowledges">
    <div
      slot="title"
      class="user-avatar d-flex align-items-center justify-content-center"
    >
      <p class="mb-0 avatar-initial">{{ initial }}</p>
    </div>
    <div class="dropdown-header d-flex align-items-center">
      <div
        slot="title"
        class="user-avatar d-flex mr-2 align-items-center justify-content-center"
      >
        <p class="mb-0 avatar-initial">{{ initial }}</p>
      </div>
      <p class="mb-0 full-username">
        <small>{{ username }}</small>
      </p>
    </div>

    <div class="dropdown-divider"></div>

    <div
      class="dropdown-header dropdown-footer d-flex align-items-center"
      @click="refreshKnowledge"
    >
      <font-awesome-icon
        class="dropdown-icon mr-2"
        :icon="['fad', 'sync']"
      ></font-awesome-icon>
      <p class="dropdown-label">
        {{ $t('mayday-web.avatar-dropdown.refresh-knowledge') }}
      </p>
    </div>

    <div class="dropdown-divider"></div>

    <div v-if="remainingKnowledges.length">
      <div
        class="dropdown-header dropdown-footer d-flex align-items-center"
        @click.stop="updateDisplayKnowledges"
      >
        <font-awesome-icon
          class="dropdown-icon mr-2"
          :icon="['fad', 'books']"
        ></font-awesome-icon>
        <p class="dropdown-label">
          {{ $t('mayday-web.avatar-dropdown.change-kb') }}
        </p>
      </div>
      <div v-if="displayKnowledges" class="overflow">
        <div
          class="dropdown-header dropdown-footer d-flex align-items-center"
          v-for="knowledge in remainingKnowledges"
          :key="knowledge.id"
          @click="
            goToWebTranslatedEntity({
              entityId: knowledge.id,
              entityType: 'Knowledge',
              lang: knowledge.defaultLanguage,
            })
          "
        >
          <IconWrapper
            class="title-icon-background pr-2"
            :icon="knowledge.icon"
            :size="14"
          />
          <p class="mb-0">
            <small>{{ knowledge.label }}</small>
          </p>
        </div>
      </div>

      <div class="dropdown-divider"></div>
    </div>

    <div
      class="dropdown-header dropdown-footer d-flex align-items-center"
      @click="$emit('open-feedback')"
    >
      <font-awesome-icon
        class="dropdown-icon mr-2"
        :icon="['fad', 'megaphone']"
      ></font-awesome-icon>
      <p class="dropdown-label">
        {{ $t('mayday-web.avatar-dropdown.global-feedback') }}
      </p>
    </div>

    <div v-if="isAdmin" class="dropdown-divider"></div>

    <div
      v-if="isAdmin"
      class="dropdown-header dropdown-footer d-flex align-items-center"
      @click="goToAdmin"
    >
      <font-awesome-icon
        class="dropdown-icon mr-2"
        :icon="['fad', 'user-cog']"
      />
      <p class="dropdown-label">
        {{ $t('mayday-web.avatar-dropdown.admin') }}
      </p>
    </div>

    <div class="dropdown-divider"></div>

    <div
      class="dropdown-header dropdown-footer d-flex align-items-center"
      @click="logout"
    >
      <font-awesome-icon
        class="dropdown-icon mr-2"
        :icon="['fad', 'sign-out']"
      ></font-awesome-icon>
      <p class="dropdown-label">
        {{ $t('mayday-web.avatar-dropdown.logout') }}
      </p>
    </div>
  </base-dropdown>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import IconWrapper from '@/components/IconWrapper';

export default {
  name: 'MaydayWebUserAvatar',
  data() {
    return {
      displayKnowledges: false,
    };
  },
  components: {
    IconWrapper,
  },
  computed: {
    initial() {
      return this.username ? this.username.slice(0, 1) : 'x';
    },
    ...mapState(['username']),
    ...mapGetters(['isParametric', 'isAdmin']),
    ...mapGetters('webKnowledgeModule', ['focusKnowledge', 'knowledges']),
    remainingKnowledges() {
      return this.focusKnowledge
        ? this.knowledges.filter((kb) => kb.id !== this.focusKnowledge.id)
        : false;
    },
  },
  methods: {
    hideKnowledges(isDropdownOpen) {
      if (!isDropdownOpen) {
        this.displayKnowledges = false;
      }
    },
    updateDisplayKnowledges() {
      this.displayKnowledges = !this.displayKnowledges;
    },
    changeKnowledge(knowledgeId) {
      const path = `/web/knowledge/${knowledgeId}`;
      this.$router.push({ path: path });
    },
    async refreshKnowledge() {
      await this.initKnowledge();

      if (this.isParametric) {
        this.$router.push({ path: '/web-parametric' });
      } else if (this.$route.name === 'mayday-web') {
        this.$router.go();
      } else {
        this.$router.push({ path: '/web' });
      }
    },
    goToAdmin() {
      this.$router.push({ path: '/knowledge' });
    },
    ...mapActions('webKnowledgeModule', [
      'initKnowledge',
      'goToWebTranslatedEntity',
    ]),
    ...mapActions(['logout']),
  },
};
</script>
<style lang="scss" scoped>
.user-avatar {
  cursor: pointer;
  height: 40px;
  width: 40px;
  border-radius: 40px;
  border: 4px solid white;
  background-color: #00587a;
  color: white;
  font-weight: 700;
  box-shadow: 0px 5px 30px rgba(112, 144, 176, 0.5);
}

.dropdown-icon {
  min-width: 16px;
  min-height: 16px;
}

.dropdown-label {
  font-size: 12px;
  color: $grey-8-mayday;
  margin-bottom: 0px;
}

.full-username {
  color: $black-mayday;
}
.dropdown-footer {
  color: $grey-6-mayday;
  cursor: pointer;
  &:hover {
    color: $blue-mayday;
  }
}

.overflow {
  max-height: 40vh;
  overflow-y: auto;
}
</style>
